<template>
  <!-- Dialog to prompt users if they need a waiver request or need to edit loan -->
  <v-dialog v-model="dialog" overlay-opacity="0.85" persistent max-width="460">
    <v-card class="pt-2">
      <v-card-title class="headline pl-10">
        Loan Waiver Required
        <v-spacer></v-spacer>
      </v-card-title>
      <!-- <v-divider></v-divider> -->
      <v-card-text class="mt-0 pt-0">
        <v-subheader class="mb-2"
          >The loan terms below require a waiver for the loan to be
          approved:</v-subheader
        >
        <ul class="pl-4" style="list-style: none">
          <li class="mb-1" v-for="(value, key) in loanWaiver" :key="key">
            <span class="d-block font-weight-medium">{{ value?.name }}</span>
            <span v-if="key === 'loanAmount'">
              {{ asMoney(value?.prev) }} to {{ asMoney(value?.cur) }}
            </span>
            <span v-else-if="key === 'frequencyTenure'">
              {{ value?.prev }} {{ loan?.frequencyNoun || '-' }}(s) to
              {{ value?.cur }} {{ loan?.frequencyNoun || '-' }}(s)
            </span>
            <span v-else>
              {{ asPercent(value?.prev) }} to {{ asPercent(value?.cur) }}
            </span>
          </li>
        </ul>

        <div class="mt-3 py-3">
          <v-btn
            text
            block
            outlined
            :disabled="loading"
            class="shadow"
            @click="dialog = false"
          >
            <v-icon>mdi-chevron-left</v-icon>
            GO BACK TO Editing Loan Details
          </v-btn>

          <v-btn
            block
            class="mt-4"
            color="error"
            :loading="loading"
            :disabled="loading"
            @click="proceed"
          >
            Proceed with loan terms
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import CoreMixin from '@/mixins/core.mixin';

export default {
  mixins: [CoreMixin],
  data() {
    return {
      loan: {},
      loading: false,
      dialog: false,
      keyToNameMap: {
        loanAmount: 'Loan Amount',
        frequencyTenure: 'Tenure',
        interest: 'Interest',
        shares: 'Shares',
        valueCollateralUsed: 'LTV'
      }
    };
  },

  computed: {
    loanWaiver: function () {
      const waiver = {};
      const { loanTermWaiver, maxTerms } = this.loan;
      for (const k in loanTermWaiver) {
        const maxKey = k;
        if (!maxTerms[maxKey]) continue;

        if (['interest', 'shares'].includes(k)) {
          waiver[k] = {
            name: this.keyToNameMap[k],
            prev: maxTerms[maxKey],
            cur: +maxTerms[maxKey] - +loanTermWaiver[k]
          };
          continue;
        }

        waiver[k] = {
          name: this.keyToNameMap[k],
          prev: maxTerms[maxKey],
          cur: +maxTerms[maxKey] + +loanTermWaiver[k]
        };
      }
      return waiver;
    }
  },

  methods: {
    openDialog(loanDetails) {
      this.loan = loanDetails;
      this.dialog = true;
    },

    proceed() {
      this.dialog = false;
      this.$emit('proceed');
    }
  }
};
</script>
